<template>
  <div class="grid gap-4 my-4">
    <AtomBlockHeader v-if="block.data?.title || block.data?.excerpt"
      :heading="block.data?.title"
      :leading="block.data?.excerpt"
    />
    <BlocksRestaurantOffersStandard :meals="meals" :date="date" />
  </div>
</template>

<script setup>
const dayjs = useDayjs()
const app = useAppStore()
const fat = useFatStore()

const props = defineProps({
  block: Object
})

// Get tags
const tagSlugs = computed(() => props.block?.data?.tagSlugs)

// Set date (use today for now) 
const date = computed(() => dayjs().format('YYYY-MM-DD'))

// Get City and City ID's from app store
const cities = computed(() => app.cities?.filter(city => tagSlugs.value?.includes(city.slug)))
const cityIds = computed(() => [...new Set(cities.value?.flatMap(city => [city.id, ...(city.relatedCityIds || [])]))])

// Fetch FAT result for Offers
const { data } = await useFetch('/search/fat', {
  key: `offers-${cityIds.value?.join('-')}`,
  baseURL: useEnv('apiBase'),
  query: {
    date: computed(() => date.value),
    cityIds: computed(() => cityIds.value ? cityIds.value.join(',') : undefined),
    amount: computed(() => fat.amount || 2),
    mealTypes: 11,
    altType: dayjs(date.value).isToday() ? '1,2,3' : '1,2',
    promotionTypes: computed(() => cityIds.value ? 'offers' : undefined),
  }
})

// Get offer meals from FAT response
const meals = computed(() => useOffersFromFat(data.value?.data?.restaurants))
</script>


<style lang="scss" scoped>
.offers-list {
  $block: &;
  @apply grid grid-cols-12 gap-4 md:gap-6;

  // 1 item
  &__item {
    #{$block}[data-items='1'] & {
      @apply col-span-full;
    }
  }

  // 2 items
  &__item {
    #{$block}[data-items='2'] & {
      @apply col-span-full md:col-span-6;
    }
  }

  // 3 items
  &__item {
    #{$block}[data-items='3'] & {
      @apply col-span-6;

      &:nth-child(1) {
        @apply col-span-full;
      }
    }
  }

  // 4 items
  &__item {
    #{$block}[data-items='4'] & {
      @apply col-span-6 lg:col-span-4;

      &:nth-child(1) {
        @apply col-span-full;
      }
    }
  }

  // 5 items
  &__item {
    #{$block}[data-items='5'] & {
      @apply col-span-6 lg:col-span-3;

      &:nth-child(1) {
        @apply col-span-full;
      }
    }
  }

  // 6 or more
  &__item {
    #{$block}[data-items='6'] & {
      @apply col-span-6 lg:col-span-3;

      &:nth-child(1) {
        @apply col-span-full;
      }

      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4) {
        @apply md:col-span-4;
      }

      &:nth-child(n+13) {
        @apply col-span-full sm:col-span-3 md:col-span-6 lg:col-span-4;
      }
    }
  }
}
</style>